export default __webpack_public_path__ + "static/media/sertifika.7e6b722f.jpg";